import { render, staticRenderFns } from "./CoreItemTwo.vue?vue&type=template&id=e3d31092&scoped=true"
import script from "./CoreItemTwo.vue?vue&type=script&lang=js"
export * from "./CoreItemTwo.vue?vue&type=script&lang=js"
import style0 from "./CoreItemTwo.vue?vue&type=style&index=0&id=e3d31092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d31092",
  null
  
)

export default component.exports